import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { apiInstance } from '../../axiosApi';

export const companyRoleGet = createAsyncThunk('companyRole', async (params) => {
  return await apiInstance.get('/role/companyRole', { params });
});

export const companyRoleOptionsGet = createAsyncThunk('companyRole-options', async () => {
  return await apiInstance.get('/role/companyRole');
});

export const companyRoleDelete = createAsyncThunk('companyRole-delete', async (id) => {
  return await apiInstance.delete(`/role/companyRole/${id}`);
});

export const companyRoleGetById = createAsyncThunk('companyRole-get', async (id) => {
  return await apiInstance.get(`/role/companyRole/${id}`);
});

export const companyRoleAdd = createAsyncThunk('companyRole-add', async (payload) => {
  return await apiInstance.post('/role/companyRole', payload);
});

export const companyRoleUpdate = createAsyncThunk('companyRole-update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/role/companyRole/${id}`, rest);
});

const initialState = {
  companyRoleList: null
};

const companyRoleSlice = createSlice({
  name: 'companyRole',
  initialState,
  reducers: {
    clearCompanyRoleSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(companyRoleGet.fulfilled, (state, action) => {
      state.companyRoleList = action?.payload;
    });
  }
});

export default companyRoleSlice.reducer;
export const { clearCompanyRoleSlice } = companyRoleSlice.actions;

export const selectCompanyRoleList = (state) => state.companyRole.companyRoleList;
export const useCompanyRoleList = () => {
  const companyRoleList = useSelector(selectCompanyRoleList);
  return useMemo(() => companyRoleList, [companyRoleList]);
};
